import { ILogger } from "./ILogger";
import { LogLevel } from "./LogLevel";

export class Logger implements ILogger {
    public readonly ignoreLevels: ReadonlyArray<LogLevel>;
    private readonly loggers: Array<ILogger>;

    public constructor(loggers: Array<ILogger>, ignoreLevels?: Array<LogLevel>) {
        this.loggers = loggers ?? [];
        this.ignoreLevels = ignoreLevels ?? [];
    }

    public debug(message: string): void {
        this.log(message, LogLevel.Debug);
    }

    public info(message: string): void {
        this.log(message, LogLevel.Info);
    }

    public warn(message: string): void {
        this.log(message, LogLevel.Warn);
    }

    public event(message: string, attachments?: Record<string, string>): void {
        if (this.ignoreLevels.includes(LogLevel.Event)) {
            return;
        }
        this.loggers.forEach((logger) => logger.event(message, attachments));
    }

    public error(message?: string): void
    public error(exception?: unknown): void
    public error(message?: string, exception?: unknown): void {
        if (this.ignoreLevels.includes(LogLevel.Error)) {
            return;
        }
        this.loggers.forEach((logger) => logger.error(message, exception));
    }

    private log(message: string, logLevel: LogLevel): void {
        if (this.ignoreLevels.includes(logLevel)) {
            return;
        }
        switch (logLevel) {
            case LogLevel.Debug:
                this.loggers.forEach((logger) => logger.debug(message));
                break;
            case LogLevel.Info:
                this.loggers.forEach((logger) => logger.info(message));
                break;
            case LogLevel.Warn:
                this.loggers.forEach((logger) => logger.warn(message));
                break;
            default:
                return;
        }
    }
}